var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11111 28C2.25556 28 1.52289 27.6956 0.913111 27.0869C0.30437 26.4771 0 25.7444 0 24.8889V3.11111C0 2.25556 0.30437 1.52289 0.913111 0.913111C1.52289 0.30437 2.25556 0 3.11111 0H24.8889C25.7444 0 26.4771 0.30437 27.0869 0.913111C27.6956 1.52289 28 2.25556 28 3.11111V24.8889C28 25.7444 27.6956 26.4771 27.0869 27.0869C26.4771 27.6956 25.7444 28 24.8889 28H3.11111ZM11.8222 19.8722C12.0296 19.8722 12.2241 19.8401 12.4056 19.7758C12.587 19.7104 12.7556 19.6 12.9111 19.4444L21.7389 10.6167C22.0241 10.3315 22.1667 9.98148 22.1667 9.56667C22.1667 9.15185 22.0111 8.78889 21.7 8.47778C21.4148 8.19259 21.0519 8.05 20.6111 8.05C20.1704 8.05 19.8074 8.19259 19.5222 8.47778L11.8222 16.1778L8.43889 12.7944C8.1537 12.5093 7.8037 12.3667 7.38889 12.3667C6.97407 12.3667 6.61111 12.5222 6.3 12.8333C6.01482 13.1185 5.87222 13.4815 5.87222 13.9222C5.87222 14.363 6.01482 14.7259 6.3 15.0111L10.7333 19.4444C10.8889 19.6 11.0574 19.7104 11.2389 19.7758C11.4204 19.8401 11.6148 19.8722 11.8222 19.8722Z",
    fill: "#5D5DED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxFull);
export default __webpack_public_path__ + "static/media/checkboxFull.1e7e17c86a6424fab2b0dcb713bdad0a.svg";
export { ForwardRef as ReactComponent };